export default __webpack_public_path__ + "static/data_augmenting-a8c8478618ab65390b6d4d1ac955660a.svg";